"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Fireworks will deploy (with a BANG!!) once an active
// user (who is signed in) has completed her G2G
var Fireworks = function Fireworks(_ref) {
    var user = _ref.user;

    if (user && user.isG2G && user.prompt) {
        return _react2.default.createElement(
            "div",
            { className: "pyro" },
            _react2.default.createElement("div", { className: "before" }),
            _react2.default.createElement("div", { className: "after" })
        );
    } else {
        return _react2.default.createElement("div", null);
    }
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        user: state.user
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Fireworks);
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./app/components/Fireworks.js
// module id = 1297
// module chunks = 0